import { render, staticRenderFns } from "./accessPoint.vue?vue&type=template&id=0b1da9d0&scoped=true&"
import script from "./accessPoint.vue?vue&type=script&lang=js&"
export * from "./accessPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1da9d0",
  null
  
)

export default component.exports